/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StaffMediaProblemFromJSON, StaffMediaProblemToJSON, } from './StaffMediaProblem';
/**
 * Check if a given object implements the StaffMediaMetrics interface.
 */
export function instanceOfStaffMediaMetrics(value) {
    let isInstance = true;
    return isInstance;
}
export function StaffMediaMetricsFromJSON(json) {
    return StaffMediaMetricsFromJSONTyped(json, false);
}
export function StaffMediaMetricsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'queued': !exists(json, 'queued') ? undefined : json['queued'],
        'processing': !exists(json, 'processing') ? undefined : json['processing'],
        'stuck': !exists(json, 'stuck') ? undefined : json['stuck'],
        'stuckAfterMinutes': !exists(json, 'stuckAfterMinutes') ? undefined : json['stuckAfterMinutes'],
        'failedInPeriod': !exists(json, 'failedInPeriod') ? undefined : json['failedInPeriod'],
        'threatsInPeriod': !exists(json, 'threatsInPeriod') ? undefined : json['threatsInPeriod'],
        'medianProcessingSeconds': !exists(json, 'medianProcessingSeconds') ? undefined : json['medianProcessingSeconds'],
        'processingSampleSize': !exists(json, 'processingSampleSize') ? undefined : json['processingSampleSize'],
        'medianSizeRatio': !exists(json, 'medianSizeRatio') ? undefined : json['medianSizeRatio'],
        'sizeRatioSampleSize': !exists(json, 'sizeRatioSampleSize') ? undefined : json['sizeRatioSampleSize'],
        'recentProblems': !exists(json, 'recentProblems') ? undefined : (json['recentProblems'] === null ? null : json['recentProblems'].map(StaffMediaProblemFromJSON)),
    };
}
export function StaffMediaMetricsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'queued': value.queued,
        'processing': value.processing,
        'stuck': value.stuck,
        'stuckAfterMinutes': value.stuckAfterMinutes,
        'failedInPeriod': value.failedInPeriod,
        'threatsInPeriod': value.threatsInPeriod,
        'medianProcessingSeconds': value.medianProcessingSeconds,
        'processingSampleSize': value.processingSampleSize,
        'medianSizeRatio': value.medianSizeRatio,
        'sizeRatioSampleSize': value.sizeRatioSampleSize,
        'recentProblems': value.recentProblems === undefined ? undefined : (value.recentProblems === null ? null : value.recentProblems.map(StaffMediaProblemToJSON)),
    };
}
